<template>
  <section class="multi-offer-container">
    <div v-if="offer.tcm" id="multi-offer-view" class="container">
      <div data-testid="multi-offers-revamp" class="destinations-header">
        <h2 class="title">{{ translate('offCheckOutOurDestinations') }}</h2>
        <MultiOffersLocationFilter
          :locations="allLocations"
          @selectedLocation="locationSelected"/>
      </div>
      <tabs v-if="!emptyResults" />
    </div>
    <div v-if="displayMap" class="pricemap-container">
      <div class="container">
        <h2 class="title">{{ translate('offExploreHotels') }}</h2>
      </div>
      <PriceMap
        :hotels="allHotels || []"
        :prices="allPrices || []"
        :clusterOptions="{
          minimumClusterSize: 2,
          gridSize: 30,
          markerPadding: 10
        }"
        :zoom="zoom"
      />
    </div>
  </section>
</template>

<script>
import { createNamespacedHelpers } from 'vuex'
import Tabs from '@/components/multi-offers/Tabs'
import MultiOffersLocationFilter from '@/components/multi-offers/Filters/MultiOffersLocationFilter'

const { mapActions, mapGetters } = createNamespacedHelpers('offersDestinations')

export default {
  name: 'MultiOffers',
  components: {
    MultiOffersLocationFilter,
    Tabs,
    PriceMap: () => import('@/components/multi-offers/PriceMap')
  },
  data: () => ({
    zoom: Number(global.appGlobalProps.offersData.zoom) || 2,
    displayMap: global.appGlobalProps.offersData.displayMap
  }),
  async created() {
    try {
      await this.getLocation()
      this.getPrices()
    } finally {
      this.$store.dispatch('sendAnalyticsView')
    }
  },
  computed: {
    ...mapGetters(['allLocations', 'allHotels', 'allPrices', 'offer', 'allDestinations', 'hotDestinations']),
    emptyResults() {
      return this.allDestinations.length === 0 && this.hotDestinations.length === 0
    }
  },
  methods: {
    ...mapActions(['getLocation', 'getPrices', 'selectLocation']),
    async locationSelected (location) {
      await this.selectLocation(location)
    }
  }
}
</script>

<style scoped lang="scss">
.multi-offer-container {
  margin-bottom: 2.5rem;
}

.destinations-header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  margin-top: 2.5rem;
}

.title {
  font-size: 2.25rem;
  font-weight: 400;
  margin-bottom: 2.5rem;
}

.pricemap-container {
  width: 100vw;
  margin-top: 7.4rem;
}
</style>
